const notification = {
    portugues: {
        notificationButtonAllow: 'Permitir',
        notificationButtonNotAllow: 'Não Permitir',
        notificationTitle: 'Inscrever-se para notificações',
        notificationText: 'Receba nossas atualizações,<br>novidades e promoções exclusivas!',
        notificationCheck: 'Verifique a barra de endereço do seu navegador para confirmar a permissão.',
        notificationMsgStatus: "Notificações Bloqueadas!<br>Para modificar as permissões das notificações, acesse as configurações do seu navegador."
    
    },
    ingles: {
        notificationButtonAllow: 'Allow',
        notificationButtonNotAllow: 'Not allow',
        notificationTitle: 'Sign up for notifications',
        notificationText: 'Receive our updates,<br>news and exclusive promotions!',
        notificationCheck: 'Check your browser address bar to confirm permission.',
        notificationMsgStatus: "Blocked Notifications!<br>To modify notification permissions, access your browser settings."
    }
  }
  
  export default notification